// Importa o módulo específico, e não o barril `@plone/volto/helpers`: o barril
// arrasta `Html.jsx` -> `serialize-javascript`, que exige `crypto` global e
// derruba qualquer suíte de teste que apenas precise resolver uma imagem.
import { isInternalURL, flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { isEmpty } from 'lodash';
// Módulo direto em vez do barril do próprio pacote: além de o barril importar
// a si mesmo de volta, ele reexporta `helpers/Url/Url`, que puxa a cadeia do
// `@plone/volto/helpers` descrita acima.
import { getYoutubeImage } from 'volto-ministerio-publico-federal/helpers/Utils/Utils';

import ImgAudio from 'volto-ministerio-publico-federal/theme/assets/img/img-audio-default.png';

export function getImageURL(href, scale) {
  if (isInternalURL(href['@id'])) {
    return `${href['@id']}/@@images/image/${scale}`;
  }
}

export function getImageMultimidiaURL(href, scale, youtuScale = 'medium') {
  switch (href['@type']) {
    case 'Image':
      if (!isEmpty(href.image_field)) {
        return flattenToAppURL(getImageURL(href, scale));
      }
      break;
    case 'Audio':
      if (!isEmpty(href.image_field)) {
        return flattenToAppURL(getImageURL(href, scale));
      } else {
        return ImgAudio;
      }
    case 'Video':
      if (!isEmpty(href.image_field)) {
        return flattenToAppURL(getImageURL(href, scale));
      } else {
        return getYoutubeImage(href.getRemoteUrl, youtuScale);
      }
    default:
      return '';
  }
}
